import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AddressesPage } from '../addresses/addresses.page';
import { CartPage } from '../cart/cart.page';
import { ConfirmorderPage } from '../confirmorder/confirmorder.page';
import { MenuPage } from '../menu/menu.page';
import { OrdersPage } from '../orders/orders.page';
import { ProductPage } from '../product/product.page';
import { ProfilePage } from '../profile/profile.page';
import { SigninPage } from '../signin/signin.page';
import { SignupPage } from '../signup/signup.page';
import { SlidePage } from '../slide/slide.page';
import { SliderPage } from '../slider/slider.page';
import { SmsPage } from '../sms/sms.page';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage {

  cart = 25;

  slides = [];

  new_products = [];
  recommend_products = [];
  popular_products = [];

  array = [1,2,3,4,5,6,7,8,9,10,11,12,13,14];

  constructor(public http:HttpClient, public translate:TranslateService, public toastCtrl:ToastController, public modalController:ModalController) {
  // this.openModal(ConfirmorderPage);
    this.get_products();
    this.http.get<any>('https://api.blowjob.cherish.com.ua/api/get_home_slides').subscribe(async res => {
      if (res.error_code == 0) {
        this.slides = res.data.slides;
      } else {
        await (await (this.toastCtrl.create({message: translate.instant('UNKNOW_ERROR')}))).present();
      }
    }, async err => {
      await (await (this.toastCtrl.create({message: translate.instant('CONNECTION_ERROR'), duration:5000 }))).present();
    })
  }

  openMenu(){
    this.openModal(MenuPage);
  }

  get_products(){
    this.get_products_func(1);
    this.get_products_func(2);
    this.get_products_func(3);
  }

  get_products_func(list){
    this.http.post<any>('https://api.blowjob.cherish.com.ua/api/get_list',{list: list}).subscribe(async res => {
      if (res.error_code == 0) {
        switch (list) {
          case 1: this.new_products = res.data.products; break;
          case 2: this.popular_products = res.data.products; break;
          case 3: this.recommend_products = res.data.products; break;
        }
      } else {
        await (await (this.toastCtrl.create({message: this.translate.instant('UNKNOW_ERROR')}))).present();
      }
    }, async err => {
      await (await (this.toastCtrl.create({message: this.translate.instant('CONNECTION_ERROR'), duration:5000 }))).present();
    })
  }

  formatArray(array){
    let result = [];

    let counter = -1;
    for(let i = 0; i < array.length; i++){
      if(i%5 == 0){ counter++; result[counter] = []; }
      result[counter][i%5] = array[i];
    }

    console.log(result);

    return result;
  }  
  
  async openProduct(product) {
    const modal = await this.modalController.create({
      component: ProductPage,
      componentProps:{
        id: String(product.id)
      },
      cssClass: 'product_modal'
    });
    return await modal.present();
  }

  async openSlide(slide) {
    const modal = await this.modalController.create({
      component: SlidePage,
      componentProps:{
        slide: slide
      },
      cssClass: 'my-custom-class'
    });
    return await modal.present();
  }

  async go_orders(){
    if(localStorage.getItem('token')){
      this.openModal(OrdersPage);
    } else {
      this.openModal(SigninPage);
    }
  }
  
  go_profile(){
    if(localStorage.getItem('token')){
      this.openModal(ProfilePage);
    } else {
      this.openModal(SigninPage);
    }
  }
  
  go_addresses(){
    if(localStorage.getItem('token')){
      this.openModal(AddressesPage);
    } else {
      this.openModal(SigninPage);
    }
  }

  async openCart() {
    if (localStorage.getItem('token')) {
      this.openModal(CartPage);
    } else {
      this.openModal(SigninPage);
    }
  }

  async openModal(component){
    await(await(this.modalController.create({component:component}))).present();
  }

}
